'use strict';

import template from './calendar.html';

const saCalendar = [
  'calendar',

  function (calendar) {
    return {
      template: template,
      replace: true,
      require: 'ngModel',
      scope: {
        disabledDates: '=',
        allowEmptyValues: '@',
        minDate: '=',
        maxDate: '=',
      },
      link: function ($scope, $element, $attr, ngModel) {
        var shouldAllowEmptyValues = ($scope.allowEmptyValues !== 'false');
        var calendarModel;

        function setDate(date) {
          var newValue = (date !== $scope.selectedDate || !shouldAllowEmptyValues) ? date : null;

          $scope.selectedDate = newValue;
          ngModel.$setViewValue(newValue);
        }

        $scope.previousMonth = function () {
          if (calendarModel.currentMonth > 0) {
            calendarModel.currentMonth--;
          }
        };

        $scope.nextMonth = function () {
          if (calendarModel.currentMonth < calendarModel.months.length - 1) {
            calendarModel.currentMonth++;
          }
        };

        $scope.selectDay = function (day) {
          if (!day.isDisabled) {
            setDate(day.fullDate);
          }
        };

        ngModel.$render = function () {
          var modelValue;

          calendarModel = calendar.getCalendar(ngModel.$modelValue, $scope.disabledDates, $scope.minDate, $scope.maxDate);
          $scope.calendar = calendarModel;
          modelValue = $scope.calendar.selectedDate;

          if (modelValue) {
            setDate(modelValue);
          } else if (!shouldAllowEmptyValues) {
            setDate($scope.calendar.today);
          }
        };
        $scope.$watch(function(){
          return $scope.minDate;
        },function(){
          var modelValue;
          calendarModel = calendar.getCalendar(ngModel.$modelValue, $scope.disabledDates, $scope.minDate, $scope.maxDate);
          $scope.calendar = calendarModel;
          modelValue = $scope.calendar.selectedDate;
          if (modelValue) {
            setDate(modelValue);
          } else if (!shouldAllowEmptyValues) {
            setDate($scope.calendar.today);
          }
        })
      }
    };
  }
];

export default saCalendar;



// WEBPACK FOOTER //
// ./app/src/directives/calendar.js